'use strict';

(function () {
	function getPauseOnMouseEnter(dataset) {
		// data-pause-on-mouse-enter → dataset.pauseOnMouseEnter (camelCase)
		var v =
			dataset.pauseOnMouseEnter ||
			dataset.pauseOnMouseenter ||
			dataset['pause-on-mouse-enter'];
		return v === 'true' || v === true;
	}

	function initAnnouncementBar(root) {
		if (!root || !root.querySelector) return;
		var swiperEl = root.querySelector('.swiper');
		if (!swiperEl) return;

		// Avoid stacking Swiper instances when customizer re-renders or settings change
		if (swiperEl.swiper && typeof swiperEl.swiper.destroy === 'function') {
			swiperEl.swiper.destroy(true, true);
		}

		var d = root.dataset;
		var autoplayEnabled = d.autoplay === 'true';
		var pauseOnMouseEnter = getPauseOnMouseEnter(d);
		var loopEnabled = d.loop === 'true';
		var delay = parseInt(d.delay, 10) || 2500;
		var speed = parseInt(d.speed, 10) || 1600;
		var slidesPerView = parseInt(d.slidesPerView, 10) || 1;

		var autoplay =
			autoplayEnabled
				? {
						delay: delay,
						disableOnInteraction: false,
						pauseOnMouseEnter: pauseOnMouseEnter,
				  }
				: false;

		new Swiper(swiperEl, {
			lazy: false,
			pagination: false,
			navigation: false,
			slidesPerView: 1,
			keyboard: { enabled: true },
			mousewheel: true,
			autoplay: autoplay,
			loop: loopEnabled,
			speed: speed,
			breakpoints: {
				1166: {
					slidesPerView: slidesPerView,
				},
			},
		});
	}

	function initAllAnnouncementBars(container) {
		var scope = container && container.querySelectorAll ? container : document;
		var roots = scope.querySelectorAll ? scope.querySelectorAll('.announcement-bar') : [];
		for (var i = 0; i < roots.length; i++) {
			initAnnouncementBar(roots[i]);
		}
	}

	function onSectionLoad(event) {
		var section = event.target;
		if (section && section.querySelector && section.querySelector('.announcement-bar')) {
			initAllAnnouncementBars(section);
		}
	}

	function onSectionUnload(event) {
		var section = event.target;
		if (!section || !section.querySelectorAll) return;
		var swipers = section.querySelectorAll('.announcement-bar .swiper');
		for (var i = 0; i < swipers.length; i++) {
			if (swipers[i].swiper && typeof swipers[i].swiper.destroy === 'function') {
				swipers[i].swiper.destroy(true, true);
			}
		}
	}

	// Customizer often patches section HTML on setting change without a full reload —
	// section:select + rAF picks up updated data-* (e.g. pause on hover).
	function onSectionSelect(event) {
		var section = event.target;
		if (!section || !section.querySelector || !section.querySelector('.announcement-bar')) return;
		requestAnimationFrame(function () {
			initAllAnnouncementBars(section);
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		initAllAnnouncementBars();
	});
	document.addEventListener('shopify:section:load', onSectionLoad);
	document.addEventListener('shopify:section:unload', onSectionUnload);
	document.addEventListener('shopify:section:select', onSectionSelect);

	// Re-init on resize so breakpoints/slidesPerView match (single destroy+init per bar)
	var resizeTimer;
	window.addEventListener('resize', function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			initAllAnnouncementBars();
		}, 150);
	});
})();
